import type { ComponentType } from 'react'
import type { NodeLabel } from '@atbash-labs/ontology-core'
import { PartEntityPage } from './PartEntityPage'
import { ProcedureEntityPage } from './ProcedureEntityPage'
import { UtilityEntityPage } from './UtilityEntityPage'
import { VendorEntityPage } from './VendorEntityPage'

/**
 * Same-URL graduation registry consulted by `EntityResolverPage` after
 * the redirect decision. Labels listed here render a designed page at
 * `/plant/entity/:id` instead of `GenericEntityPage`. Leaves
 * `PLANT_SURFACE_BY_LABEL` / coverage specs untouched.
 */
export const BESPOKE_ENTITY_PAGE_BY_LABEL: Partial<
  Record<NodeLabel, ComponentType<{ entityId: string; label: NodeLabel }>>
> = {
  Part: PartEntityPage,
  Procedure: ProcedureEntityPage,
  Utility: UtilityEntityPage,
  Vendor: VendorEntityPage
}
